import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { EmailDuplicateDirective } from './email-duplicate.directive';

@NgModule({
    imports: [MaterialModule],
    exports: [EmailDuplicateDirective],
    declarations: [EmailDuplicateDirective],
    providers: []
})
export class EmailDuplicateModule {}
